import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios'; // Import axios for API requests
import { FaCheck } from 'react-icons/fa6';
import './ResetPassword.css';

function ResetPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordAgain, setPasswordAgain] = useState('');
  const [showMessage, setShowMessage] = useState(false); // State for showing the message
  const navigate = useNavigate();
  const location = useLocation(); // Get location object to access URL parameters
  const [token, setToken] = useState(''); // State to store the token

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get('token'); // Extract the token from the URL
    setToken(tokenFromUrl); // Set the token in the state
    console.log('Token from URL:', tokenFromUrl); // Log the token for debugging
  }, [location.search]);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const navigateToLogin = () => {
    navigate('/');
  }


  const handlePasswordAgainChange = (e) => {
    setPasswordAgain(e.target.value);
  };

  const handleResetPassword = async () => {
    const passwordMinLength = 12;
    const hasUpperCase = /[A-Z]/;
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

    if (
        password.length < passwordMinLength ||
        !hasUpperCase.test(password) ||
        !hasSpecialChar.test(password)
    ) {
        alert('รหัสผ่านของคุณต้องมีอักขระอย่างน้อย 12 ตัว ตัวพิมพ์ใหญ่ 1 ตัว และอักขระพิเศษ 1 ตัว');
        return; // Exit the function if validation fails
    }

    if (password !== passwordAgain) {
        alert('รหัสผ่านไม่ตรงกัน');
        return; // Exit the function if passwords don't match
    }

    try {
        const payload = new URLSearchParams({
            token: token,
            new_password: password,
        });

        await axios.post('https://sso-uficon-xuvbdxggia-uc.a.run.app/reset-password', payload, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });

        setShowMessage(true);

    } catch (error) {
        console.error('Error resetting password:', error);
    }
};



  return (
    <div className="App">
      <header className="App-header">

      <div
                  style={{
                    width: '100%',
                    maxWidth: '500px',
                    minWidth: '300px',
                    height: '100%',
                    backgroundColor: '#f2f3f5',
                    padding: '50px',
                    boxSizing: 'border-box',
                  }}
                >

                  <img src="/assets/logo U-01.png" alt="Logo" className="logo" />
                  <div className="forgot-text">เปลี่ยนรหัสผ่าน</div>
                  <div className="forgot-text-eng">Reset Password</div>

                  {!showMessage && (
          <>
            {/* <div className="input-group password-group">
              <div className="header-label" style={{ marginTop: '30px' }}>ใส่รหัสผ่านใหม่ด้านล่างนี้</div>
            </div> */}
            <div className="input-group password-group">
              <div className="input-label" style={{ marginTop: '30px' }}>รหัสผ่านใหม่ *</div>
              <div className="password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  className="input-field"
                  value={password}
                  onChange={handlePasswordChange}
                />
              </div>
            </div>
            <div className="input-group password-group">
              <div className="input-label" style={{ marginTop: '30px' }}>ยืนยันรหัสผ่าน *</div>
              <div className="password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  className="input-field"
                  value={passwordAgain}
                  onChange={handlePasswordAgainChange}
                />
              </div>
              <ul style={{ marginTop: '8px', paddingLeft: '20px', fontSize: '10px', color: 'grey' }}>
                <li>ต้องมีตัวอักษรภาษาอังกฤษ (a-z,A-Z) และตัวเลขรวมกันอย่างน้อย 12 ตัว</li>
                <li>ต้องมีตัวอักษรภาษาอังกฤษพิมพ์ใหญ่ (A-Z) ในรหัสผ่านอย่างน้อย 1 ตัว</li>
                <li>ต้องมีตัวอักษรพิเศษอย่างน้อย 1 ตัว เช่น !"?$%^&</li>
              </ul>
            </div>
            <div className="input-group">
              <button className="login-button" onClick={handleResetPassword}>ยืนยัน</button>
            </div>
          </>
        )}

        {showMessage && (
          <div className="message-container">
            <div className="success-message">
              <FaCheck style={{ color: 'green', marginRight: '8px' }} />
              การเปลี่ยนรหัสผ่านสำเร็จ
            </div>
            <div className="success-header">
              <div>รหัสผ่านของคุณได้ถูกเปลี่ยนเรียบร้อยแล้ว</div>
            </div>
            <div className="return-header" onClick={navigateToLogin}>
              <div>กลับสู่หน้าหลัก</div>
            </div>
          </div>
        )}
                </div>
        
      </header>
    </div>
  );
}

export default ResetPassword;
